import {AbstractControl} from '@angular/forms';
import {ErrorReference} from 'src/app/core/consts/error-reference';
import {AppError} from 'src/app/shared/library/px-ui/px-forms/models';
import {ObjectUtil} from 'src/app/shared/library/px-ui/px-forms/utils';

export class RegexPatternValidator {
    static ordnungkriterium(control: AbstractControl) {
        if (ObjectUtil.isEmpty(control.value)) {
            return null;
        }
        return RegExp('^(\\S|\\S[\\S ]{0,28}\\S)$').test(control.value.toString())
            ? null
            : { invalidFormat: new AppError(ErrorReference.ordnungkriteriumFormat) };
    }

    static geburtsdatum(control: AbstractControl) {
        if (ObjectUtil.isEmpty(control.value)) {
            return null;
        }

        return RegExp('^(0[1-9]|[12][0-9]|3[01]).(0[1-9]|1[012]).(19[0-9][0-9]|2500|2[0-4][0-9][0-9])$').test(
            control.value.toString()
        )
            ? null
            : { invalidFormat: new AppError(ErrorReference.kindGeburtsdatum) };
    }

    static abfragezeitraum(control: AbstractControl) {
        if (ObjectUtil.isEmpty(control.value)) {
            return null;
        }

        return RegExp('^(0[1-9]|1[012]).(19[0-9][0-9]|2500|2[0-4][0-9][0-9])$').test(control.value.toString())
            ? null
            : { invalidFormat: new AppError(ErrorReference.abfragezeitraum) };
    }
}
